import styled from "styled-components";

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0 15px 0;
`;

export const ExpandedContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
    padding-top: 0;

    .expanded-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .section-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${(props: any) => props.theme.colors.c64748b};
        margin-bottom: 8px;
    }

    .email-container {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        min-width: 0;
        box-sizing: border-box;

        @media (max-width: 1024px) {
            padding: 7px;
            gap: 7px;
        }

        @media (max-width: 850px) {
            padding: 6.5px;
            gap: 6.5px;
        }

        @media (max-width: 768px) {
            padding: 6px;
            gap: 6px;
            border-radius: 4px;
        }

        @media (max-width: 640px) {
            padding: 5.5px;
            gap: 5.5px;
        }

        @media (max-width: 480px) {
            padding: 5px;
            gap: 5px;
        }

        @media (max-width: 414px) {
            padding: 4px;
            gap: 4px;
        }

        @media (max-width: 375px) {
            padding: 3.5px;
            gap: 3.5px;
        }

        @media (max-width: 320px) {
            padding: 3px;
            gap: 3px;
        }

        .email-detalhes {
            font-size: 11px;
            color: ${(props: any) => props.theme.colors.c64748b};
            margin: 0;
            word-break: break-word;

            @media (max-width: 1024px) {
                font-size: 10.5px;
            }

            @media (max-width: 850px) {
                font-size: 10px;
            }

            @media (max-width: 768px) {
                font-size: 10px;
            }

            @media (max-width: 640px) {
                font-size: 9.5px;
            }

            @media (max-width: 480px) {
                font-size: 9px;
            }

            @media (max-width: 414px) {
                font-size: 8px;
            }

            @media (max-width: 375px) {
                font-size: 7px;
            }

            @media (max-width: 320px) {
                font-size: 6px;
            }
        }

        @media (min-width: 768px) {
            padding: 12px;
            gap: 8px;
        }
    }
`;

export const TableContainer = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;

    @media (max-width: 768px) {
        border-radius: 4px;
    }

    .parte-header {
        background-color: rgba(0, 0, 0, 0.03);
        padding: 6px 8px;
        font-size: 9px;
        font-weight: 500;
        text-transform: uppercase;
        color: ${(props: any) => props.theme.colors.c64748b};
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        @media (max-width: 1024px) {
            padding: 5.5px 7px;
            font-size: 8.5px;
        }

        @media (max-width: 850px) {
            padding: 5px 6.5px;
            font-size: 8px;
        }

        @media (max-width: 768px) {
            padding: 5px 6px;
            font-size: 8px;
        }

        @media (max-width: 640px) {
            padding: 4.5px 5.5px;
            font-size: 7.5px;
        }

        @media (max-width: 480px) {
            padding: 4px 5px;
            font-size: 7px;
        }

        @media (max-width: 414px) {
            padding: 3.5px 4px;
            font-size: 6px;
        }

        @media (max-width: 375px) {
            padding: 3px 3.5px;
            font-size: 6px;
        }

        @media (max-width: 320px) {
            padding: 2.5px 3px;
            font-size: 5px;
        }
    }

    .data-table {
        width: 100%;
        font-size: 12px;
        border-collapse: collapse;
        min-width: 0;

        @media (max-width: 1024px) {
            font-size: 11.4px;
        }

        @media (max-width: 850px) {
            font-size: 10.8px;
        }

        @media (max-width: 768px) {
            font-size: 10.8px;
        }

        @media (max-width: 640px) {
            font-size: 10.2px;
        }

        @media (max-width: 480px) {
            font-size: 9.6px;
        }

        @media (max-width: 414px) {
            font-size: 8.4px;
        }

        @media (max-width: 375px) {
            font-size: 7.2px;
        }

        @media (max-width: 320px) {
            font-size: 6px;
        }

        thead {
            background-color: var(--table-thead-bg);

            th {
                text-align: left;
                padding: 8px;
                font-weight: 500;
                font-size: 12px;
                color: ${({ theme }) => theme.colors.c000000};
                white-space: nowrap;

                @media (max-width: 1024px) {
                    padding: 7px;
                    font-size: 11.4px;
                }

                @media (max-width: 850px) {
                    padding: 6.5px;
                    font-size: 10.8px;
                }

                @media (max-width: 768px) {
                    padding: 6px;
                    font-size: 10.8px;
                }

                @media (max-width: 640px) {
                    padding: 5.5px;
                    font-size: 10.2px;
                }

                @media (max-width: 480px) {
                    padding: 5px;
                    font-size: 9.6px;
                }

                @media (max-width: 414px) {
                    padding: 4px;
                    font-size: 8.4px;
                }

                @media (max-width: 375px) {
                    padding: 3.5px;
                    font-size: 7.2px;
                }

                @media (max-width: 320px) {
                    padding: 3px;
                    font-size: 6px;
                }

                &.field-col {
                    width: 35%;
                }

                &.value-col {
                    width: 65%;
                }

                &.before-col {
                    width: 30%;
                }

                &.after-col {
                    width: 45%;
                }

                &.field-col-three {
                    width: 25%;
                }
            }
        }

        tbody {
            tr {
                &.border-top {
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                }

                td {
                    padding: 8px;
                    vertical-align: top;
                    word-break: break-word;
                    font-size: 12px;

                    @media (max-width: 1024px) {
                        padding: 7px;
                        font-size: 11.4px;
                    }

                    @media (max-width: 850px) {
                        padding: 6.5px;
                        font-size: 10.8px;
                    }

                    @media (max-width: 768px) {
                        padding: 6px;
                        font-size: 10.8px;
                    }

                    @media (max-width: 640px) {
                        padding: 5.5px;
                        font-size: 10.2px;
                    }

                    @media (max-width: 480px) {
                        padding: 5px;
                        font-size: 9.6px;
                    }

                    @media (max-width: 414px) {
                        padding: 4px;
                        font-size: 8.4px;
                    }

                    @media (max-width: 375px) {
                        padding: 3.5px;
                        font-size: 7.2px;
                    }

                    @media (max-width: 320px) {
                        padding: 3px;
                        font-size: 6px;
                    }

                    &.field-cell {
                        color: ${(props: any) => props.theme.colors.c64748b};
                    }

                    &.value-cell {
                        color: ${({ theme }) => theme.colors.c000000};

                        &.empty-value {
                            color: ${(props: any) => props.theme.colors.c94a3b8};
                            font-style: italic;
                        }

                        .check-icon {
                            height: 14px;
                            width: 14px;
                            color: ${(props: any) => props.theme.colors.c16a34a};

                            @media (max-width: 1024px) {
                                height: 13px;
                                width: 13px;
                            }

                            @media (max-width: 850px) {
                                height: 12.5px;
                                width: 12.5px;
                            }

                            @media (max-width: 768px) {
                                height: 12px;
                                width: 12px;
                            }

                            @media (max-width: 640px) {
                                height: 11px;
                                width: 11px;
                            }

                            @media (max-width: 480px) {
                                height: 10px;
                                width: 10px;
                            }

                            @media (max-width: 414px) {
                                height: 9px;
                                width: 9px;
                            }

                            @media (max-width: 375px) {
                                height: 8px;
                                width: 8px;
                            }

                            @media (max-width: 320px) {
                                height: 7px;
                                width: 7px;
                            }
                        }

                        .x-icon {
                            height: 14px;
                            width: 14px;
                            color: ${(props: any) => props.theme.colors.cdc2626};

                            @media (max-width: 1024px) {
                                height: 13px;
                                width: 13px;
                            }

                            @media (max-width: 850px) {
                                height: 12.5px;
                                width: 12.5px;
                            }

                            @media (max-width: 768px) {
                                height: 12px;
                                width: 12px;
                            }

                            @media (max-width: 640px) {
                                height: 11px;
                                width: 11px;
                            }

                            @media (max-width: 480px) {
                                height: 10px;
                                width: 10px;
                            }

                            @media (max-width: 414px) {
                                height: 9px;
                                width: 9px;
                            }

                            @media (max-width: 375px) {
                                height: 8px;
                                width: 8px;
                            }

                            @media (max-width: 320px) {
                                height: 7px;
                                width: 7px;
                            }
                        }
                    }

                    &.before-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                        white-space: pre-wrap;
                    }

                    &.after-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                        white-space: pre-wrap;
                    }
                }
            }
        }
    }

    @media (max-width: 640px) {
        overflow-x: auto;
        
        .data-table {
            min-width: 280px;
        }
    }

    @media (max-width: 480px) {
        .data-table {
            min-width: 240px;
        }
    }

    @media (max-width: 414px) {
        .data-table {
            min-width: 200px;
        }
    }

    @media (max-width: 375px) {
        .data-table {
            min-width: 180px;
        }
    }

    @media (max-width: 320px) {
        .data-table {
            min-width: 150px;
        }
    }
`;

export const EmailBadge = styled.span<{ status: 'sucesso' | 'falha' | 'aviso' }>`
    display: inline-flex;
    align-items: center;
    padding: 0 6px;
    border-radius: 4px;
    font-size: 9px;
    font-weight: 500;
    height: 16px;
    width: fit-content;
    
    background-color: ${({ status }) =>
        status === 'sucesso' ? 'rgb(206, 242, 209)' :
        status === 'aviso' ? 'var(--cfef3c7)' : 'var(--cfee2e2)'};
    color: ${({ status }) =>
        status === 'sucesso' ? 'rgb(10, 189, 23)' :
        status === 'aviso' ? 'var(--cb45309)' : 'var(--cdc2626)'};

    .email-icon {
        height: 10px;
        width: 10px;
        flex-shrink: 0;
        margin-right: 4px;
    }

    @media (max-width: 640px) {
        height: 15px;
        padding: 0 5px;
        font-size: 8px;

        .email-icon {
            height: 9px;
            width: 9px;
            margin-right: 3px;
        }
    }

    @media (max-width: 480px) {
        height: 14px;
        padding: 0 4px;
        font-size: 7px;

        .email-icon {
            height: 8px;
            width: 8px;
            margin-right: 2px;
        }
    }

    @media (max-width: 414px) {
        height: 13px;
        padding: 0 3.5px;
        font-size: 6px;

        .email-icon {
            height: 7px;
            width: 7px;
            margin-right: 2px;
        }
    }

    @media (max-width: 375px) {
        height: 12px;
        padding: 0 3px;
        font-size: 6px;

        .email-icon {
            height: 7px;
            width: 7px;
            margin-right: 1.5px;
        }
    }

    @media (max-width: 320px) {
        height: 11px;
        padding: 0 2.5px;
        font-size: 5px;

        .email-icon {
            height: 6px;
            width: 6px;
            margin-right: 1px;
        }
    }

    @media (min-width: 768px) {
        height: 20px;
        padding: 0 8px;
        font-size: 10px;

        .email-icon {
            height: 12px;
            width: 12px;
        }
    }
`;

